var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"header"},[_c('Header')],1),_c('div',{staticStyle:{"padding-bottom":"120px"}},[_c('router-view')],1),_c('div',{staticClass:"login",on:{"click":_vm.login}},[_c('span',[_vm._v("登录")])]),_c('div',{staticClass:"footer",domProps:{"innerHTML":_vm._s(_vm.footer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }